import { Suspense } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { PageLoader } from '@/components/common/PageLoader'
import { OloNotAvailable } from '@/components/OloNotAvailable'
import { StoreClosed } from '@/components/StoreClosed'
import { useLocationBootstrap } from '@/hooks/useLocationBootstrap'

function BootstrappedLocation() {
	const bootstrap = useLocationBootstrap()

	if (!bootstrap.isReady) return <PageLoader />

	if (bootstrap.location.isClosed) {
		const { name, addressLine1, city, state } = bootstrap.location
		const address = [addressLine1, city, state].filter(Boolean).join(', ')
		return (
			<StoreClosed
				locationName={name}
				address={address}
				message={bootstrap.location.closureReason}
			/>
		)
	}

	if (!bootstrap.location.oloStoreActive) return <OloNotAvailable />

	return (
		<Outlet
			context={{
				location: bootstrap.location,
				isStoreClosureActive: bootstrap.isStoreClosureActive,
			}}
		/>
	)
}

export default function LocationPage() {
	const { ref } = useParams()
	return (
		<ErrorBoundary key={ref}>
			<Suspense fallback={<PageLoader />}>
				<BootstrappedLocation />
			</Suspense>
		</ErrorBoundary>
	)
}
